import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { mirrorUser } from "../redux/usersSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { showToast } from "../../../../utils/showToast";
import { settingsApi } from "../api";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";

export const Mirror = ({ isOpen, onClose, selected: { id, name } }) => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const getUsersToMirror = async () => {
    const { organization_id } = getBaseUrlParams();

    let res = await settingsApi.getUsersToMirror({
      params: { organization_id, source_user_id: id }
    });
    setUsers(res.data);
  };

  useEffect(() => {
    try {
      getUsersToMirror();
    } catch (err) {
      showToast(err.data.message);
      onClose();
    }
  }, []);

  const primaryButtonDisabled = selectedUsers.length === 0;

  const onSave = () => {
    dispatch(mirrorUser({ id, data: selectedUsers }));
    onClose();
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        isLoading={!users}
        onClose={onClose}
        parentSelector=".users"
        headerText="Mirror User permissions with selected user"
        headerCloseHandler={onClose}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={onSave}
        secondaryBtnText="Cancel"
        secondaryBtnClass="secondary"
        secondaryBtnHandler={onClose}
        containerClassName="mirror"
        height="auto"
        width={600}
        isAdminPanel={false}
      >
        <Dropdown
          height={275}
          haveOnSelectChange
          enableOnly
          options={users ?? []}
          selectedFilters={selectedUsers}
          numberDisplayed={0}
          onSelectChange={setSelectedUsers}
        />
        {selectedUsers.length >= 1 && (
          <div className="text-bold">
            Note: All permissions from {name} user will be applied to
            <ol>
              {selectedUsers.map((selectedUser) => {
                return <li key={selectedUser.id}>{selectedUser.name}</li>;
              })}
            </ol>
            user{selectedUsers.length > 1 ? "s" : ""} once you click on Mirror button
          </div>
        )}
      </MainModal>
    </>
  );
};
